import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	answer: 'sn/Dialog/answer',
	drop: 'sn/Dialog/drop',
	hold: 'sn/Dialog/hold',
	retrieve: 'sn/Dialog/retrieve',
	call: 'sn/Dialog/call',
	transfer: 'sn/Dialog/transfer',
};

export const dialogApi = createApi({
	reducerPath: 'sn/dialogApi',

	endpoints: (builder) => ({
		answer: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/sn/Dialog/answer',
				body,
				jsonType: true,
			}),
			providesTags: [tags.answer],
		}),
		drop: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/sn/Dialog/drop',
				body,
				jsonType: true,
			}),
			providesTags: [tags.drop],
		}),
		hold: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/sn/Dialog/hold',
				body,
				jsonType: true,
			}),
			providesTags: [tags.hold],
		}),
		retrieve: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/sn/Dialog/retrieve',
				body,
				jsonType: true,
			}),
			providesTags: [tags.retrieve],
		}),
		call: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/sn/Dialog/call',
				body,
				jsonType: true,
			}),
			providesTags: [tags.call],
		}),
		transfer: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/sn/Dialog/transfer',
				body,
				jsonType: true,
			}),
			providesTags: [tags.transfer],
		}),
	}),
});

export const {
	answer,
	drop,
	hold,
	retrieve,
	call,
	transfer,
} = dialogApi.endpoints;

export default dialogApi;